import { render } from "./ItemsSection.vue?vue&type=template&id=066a6248&scoped=true"
import script from "./ItemsSection.vue?vue&type=script&lang=js"
export * from "./ItemsSection.vue?vue&type=script&lang=js"

import "./ItemsSection.vue?vue&type=style&index=0&id=066a6248&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066a6248"]])

export default __exports__